export var convertToRegularObject = function (obj) {
    if (obj instanceof FormData) {
        var convertedObj_1 = {};
        obj.forEach(function (value, key) {
            convertedObj_1[key] = value;
        });
        return convertedObj_1;
    }
    if (typeof obj === "object" && obj !== null) {
        var convertedObj = {};
        for (var key in obj) {
            convertedObj[key] = convertToRegularObject(obj[key]);
        }
        return convertedObj;
    }
    return obj;
};
